import useMapEnum from "src/functions/mappers/use-map-enum";
import { LoanStatusType_Enum } from "src/types/enums";

const loanStateOptions = useMapEnum(Object.values(LoanStatusType_Enum))

export default loanStateOptions;
